module.exports = __webpack_public_path__ + "static/media/arpspoofDoc.4cde2b53.png";